<template>
  <div>
    <Header class="fixed top-0 left-0 right-0 z-50" />

    <main class="pt-24 pb-16">
      <div class="container mx-auto px-4 sm:px-6 max-w-4xl">
        <h1 class="text-4xl sm:text-5xl font-barlow-condensed font-medium text-brand mb-8 text-center">
          DISCLAIMER
        </h1>

        <div class="prose prose-lg max-w-none">
          <p class="text-slate-600 mb-6 font-bold">
            Effective Date: {{ lastUpdated }}
          </p>

          <section class="mb-10">
            <p class="text-slate-600">
              The content provided on <a href="https://MeditationCircle.com" class="font-bold">MeditationCircle.com</a> is for <span class="font-bold">informational and educational purposes only</span>. By using this website, you acknowledge and agree to the following:
            </p>
          </section>

          <section class="mb-10">
            <h2 class="text-2xl font-medium text-brand">1. No Medical or Psychological Advice</h2>
            <p class="text-slate-600">
              The guided meditations, audio recordings, and other content provided are <span class="font-bold">not a substitute for professional medical or psychological advice, diagnosis, or treatment</span>. If you have a medical or mental health condition, please consult a licensed professional before using our services.
            </p>
          </section>

          <section class="mb-10">
            <h2 class="text-2xl font-medium text-brand">2. No Guarantees</h2>
            <p class="text-slate-600">
              Meditation is a personal practice, and <span class="font-bold">results vary from person to person</span>. We do not guarantee any specific outcomes regarding relaxation, stress relief, or personal transformation.
            </p>
          </section>

          <section class="mb-10">
            <h2 class="text-2xl font-medium text-brand">3. No Liability</h2>
            <p class="text-slate-600">
            <a href="https://MeditationCircle.com" class="font-bold">MeditationCircle.com</a> and its creators shall <span class="font-bold">not be held liable</span> for any issues, injuries, or consequences resulting from the use of our guided meditations or any other content provided on this site. Use at your own discretion.
            </p>
          </section>

          <section class="mb-10">
            <h2 class="text-2xl font-medium text-brand">4. External Links & Third-Party Content</h2>
            <p class="text-slate-600">
              We may provide links to external websites for reference. However, we <span class="font-bold">do not endorse or take responsibility</span> for the accuracy or safety of third-party content.
            </p>
          </section>

          <section class="mb-10">
            <h2 class="text-2xl font-medium text-brand">5. Governing Law</h2>
            <p class="text-slate-600">
              This Disclaimer is governed by the laws of <span class="font-bold">Arizona, USA</span>.<br><br>
By using <a href="https://MeditationCircle.com" class="font-bold">MeditationCircle.com</a>, you agree to this <span class="font-bold">Disclaimer</span>. If you do not agree, please discontinue use of the website.
<br><br>For inquiries, contact <a href="mailto:support@meditationcircle.com" class="font-bold">support@meditationcircle.com</a>.
            </p>
          </section>
        </div>
      </div>
    </main>

    <Footer />
  </div>
</template>

<script setup>
import { ref } from 'vue';
import Footer from '~/components/Footer.vue';
import Header from '~/components/Header.vue';

definePageMeta({
  name: 'disclaimer'
});

const lastUpdated = ref('March 19, 2025');
const mobileMenuOpen = ref(false);
</script>

<style scoped>
.prose h2 {
  margin-top: 1.5em;
  margin-bottom: 0.75em;
}

.prose p {
  margin-bottom: 1em;
  line-height: 1.7;
}

.prose ul {
  margin-top: 0.5em;
  margin-bottom: 1em;
}

.prose li {
  margin-bottom: 0.5em;
}
</style> 